import { SRMultiStylesSchema } from './SRMulti.styles';

export const srMultiStyles: SRMultiStylesSchema = {
  multiContainer: {
    mx: '4',
    p: '2',
    bg: '#495564',
    borderRadius: 'md',
    mb: '2',
  },
  multiRunnerContainer: {
    justifyContent: 'space-between',
    bgGradient: 'linear(to-b, beta.600, beta.700)',
    p: '3',
    my: '2',
    borderRadius: 'md',
  },
  buttonLabel: {
    color: 'white',
  },
  propButton: {
    w: '50px',
  },
  columnHeadings: {
    w: ['49px', null, '64px'],
    textAlign: 'center',
    fontSize: 'xs',
    color: 'gray.700',
    fontWeight: 'bold',
  },
  headingContainer: {
    textAlign: 'center',
    textTransform: 'capitalize',
    fontSize: 'xs',
    color: 'gray.700',
    marginRight: '1',
    fontWeight: 'bold',
  },
  headingLabel: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'bold',
  },
  runnerList: {
    p: '2',
    bg: 'white',
    mx: '3',
    mb: '3',
    borderRadius: '6px',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
    border: '2px solid',
    borderColor: 'beta.600',
    boxSizing: 'border-box',
  },
  headingStacker: {
    rowGap: '2',
  },
};
